module.exports = __webpack_public_path__ + "img/technology.ffd1e2bf.png";